import { MotionReveal } from "../components/MotionReveal";
import { useState } from "react";

const initial = {
  name: "",
  email: "",
  organization: "",
  role: "",
  industry: "Government",
  inquiryType: "Assessment",
  message: "",
};

export default function ContactPage() {
  const [form, setForm] = useState(initial);
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-6 sm:pt-10">
        <MotionReveal>
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[var(--text-secondary)]">
              Assessments & executive workshops
            </div>
            <h1 className="mt-6 font-[var(--font-display)] text-4xl sm:text-5xl tracking-tight text-white">
              Start Your AIOps Journey
            </h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base text-[var(--text-secondary)]">
              Let’s discuss how to transform your operations.
            </p>
          </div>
        </MotionReveal>
      </div>

      <section className="mt-10 sm:mt-14">
        <div className="grid gap-6 lg:grid-cols-2">
          <MotionReveal>
            <div className="glass-panel rounded-3xl p-6 sm:p-8">
              <div className="font-[var(--font-display)] text-xl tracking-tight text-white">Request an Assessment</div>
              <div className="mt-2 text-sm text-[var(--text-secondary)]">
                This form is a placeholder UI. Wire to your CRM/email endpoint when ready.
              </div>

              {submitted ? (
                <div className="mt-6 rounded-2xl border border-[rgba(16,185,129,0.35)] bg-white/3 p-4 text-sm text-white">
                  Submitted. We’ll follow up shortly.
                </div>
              ) : null}

              <form
                className="mt-6 grid gap-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  setSubmitted(true);
                }}
              >
                <Field
                  label="Name"
                  value={form.name}
                  onChange={(v) => setForm((s) => ({ ...s, name: v }))}
                  required
                />
                <Field
                  label="Email"
                  type="email"
                  value={form.email}
                  onChange={(v) => setForm((s) => ({ ...s, email: v }))}
                  required
                />
                <Field
                  label="Organization"
                  value={form.organization}
                  onChange={(v) => setForm((s) => ({ ...s, organization: v }))}
                />
                <Field label="Role/Title" value={form.role} onChange={(v) => setForm((s) => ({ ...s, role: v }))} />

                <Select
                  label="Industry"
                  value={form.industry}
                  onChange={(v) => setForm((s) => ({ ...s, industry: v }))}
                  options={["Government", "BFSI", "Digital-Native Enterprises", "Defence & Critical Infrastructure"]}
                />
                <Select
                  label="Inquiry Type"
                  value={form.inquiryType}
                  onChange={(v) => setForm((s) => ({ ...s, inquiryType: v }))}
                  options={["Assessment", "Demo", "Partnership", "General"]}
                />

                <div>
                  <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Message</div>
                  <textarea
                    className="mt-2 w-full rounded-2xl border border-white/10 bg-white/3 px-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
                    rows={5}
                    value={form.message}
                    onChange={(e) => setForm((s) => ({ ...s, message: e.target.value }))}
                    placeholder="Briefly describe your environment, pain points, and desired outcomes."
                  />
                </div>

                <button
                  type="submit"
                  className="mt-2 inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-[#061019] bg-[var(--accent-primary)] hover:brightness-110"
                >
                  Submit
                </button>
              </form>
            </div>
          </MotionReveal>

          <MotionReveal delay={0.1}>
            <div className="grid gap-6">
              <div className="glass-panel rounded-3xl p-6 sm:p-8">
                <div className="font-[var(--font-display)] text-xl tracking-tight text-white">Quick Contact</div>
                <div className="mt-4 grid gap-2 text-sm text-[var(--text-secondary)]">
                  <div>
                    <span className="text-white">Email:</span> info@ivalue.co.in
                  </div>
                  <div>
                    <span className="text-white">Phone:</span> +91 95359 99473
                  </div>
                  <div>
                    <span className="text-white">Office locations:</span> iValue Group (India-HQ) No. 903/1/1, 19th Main Road, 4th Sector, H.S.R. Layout, Bangalore – 560102
                  </div>
                </div>
              </div>

              <div className="glass-panel rounded-3xl p-6 sm:p-8">
                <div className="font-[var(--font-display)] text-xl tracking-tight text-white">What to Expect</div>
                <div className="mt-4 grid gap-3">
                  <Step title="Discovery Call (30 min)" desc="Understand your challenges and desired outcomes." />
                  <Step title="Assessment Proposal" desc="Tailored scope and approach." />
                  <Step title="Assessment Execution (2–4 weeks)" desc="Signal, workflow, and governance analysis." />
                  <Step title="Findings & Roadmap" desc="Executive presentation with ROI and next steps." />
                </div>
              </div>
            </div>
          </MotionReveal>
        </div>
      </section>

      <div className="h-12" />
    </div>
  );
}

function Field({ label, value, onChange, type = "text", required }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">{label}</div>
      <input
        required={required}
        type={type}
        className="mt-2 w-full rounded-2xl border border-white/10 bg-white/3 px-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function Select({ label, value, onChange, options }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">{label}</div>
      <select
        className="mt-2 w-full rounded-2xl border border-white/10 bg-white/3 px-4 py-3 text-sm text-white focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o} value={o} className="bg-[#0a0e17]">
            {o}
          </option>
        ))}
      </select>
    </div>
  );
}

function Step({ title, desc }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/3 px-4 py-3">
      <div className="text-sm text-white">{title}</div>
      <div className="mt-1 text-sm text-[var(--text-secondary)]">{desc}</div>
    </div>
  );
}
